<script>
import { componentStore } from "@common/componentStore/componentStore";
import { QRCodeGenerator } from '@syncfusion/ej2-barcode-generator';

let vmsSetupMFAConfig = {
    cId: "vmsSetupMFA",
    cType: "vmsSetupMFA",
    cTitle: "Set up Authenticator",
    cTemplate: `<div :id="wrapperID" class="vmsSetupMFA-wrapper" :class="{'is-from-popup': isFromPopup}">
                    <div class="vmsSetupMFA-title">Set up Authenticator</div>
                    <div class="vmsSetupMFA-instructionsWrapper">
                        1. Get the Authenticator App from the <a href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2' target='_blank'>Play Store</a> for Android
                        or from the <a href='https://itunes.apple.com/us/app/google-authenticator/id388497605' target='_blank'>App Store</a> for iOS;<br>
                        2. Tap the <b>plus</b> button;<br>
                        3. Tap <b>Enter provided key</b>;<br>Enter your account name and this key:<div class="vmsSetupMFA-mfaKey">{{mfaKey}}</div>Make sure that <b>Time based</b> is turned on, and tap <b>Add</b> to finish.<br>
                        4. Or tap Scan QR code and scan QR code below
                        <div class="vmsSetupMFA-qrCodeWrapper">
                            <div id="mfaQRCode"></div>
                        </div>
                    </div>
                    <div class="vmsSetupMFA-buttons">
                        <div class="vmsSetupMFA-button"><control name="SETUP_MFA_OK_BUTTON"></control></div>
                    </div>
               </div>
               `,
    controls: [
        {
            name: 'SETUP_MFA_OK_BUTTON',
            type: 'button',
            label: 'OK',
            onclick: 'save',
        },
    ]
};

let vmsSetupMFACmp = {
    name: 'vmsSetupMFA',
    preInitControls: true,
    props: {
        isFromPopup: {
            default: false
        },
        mfaKey: {
            type: 'string',
            default: '',
        },
        mfaCode: {
            type: 'string',
            default: '',
        }
    },
    data() {
        return { };
    },
    computed: {
        wrapperID() {
            return this.cId + 'Wrapper';
        },
    },
    components: {},
    methods: {
        onLoad() {
            this.$emit('update:vmsSetupMFALoaded', true);
            if (typeof this.mfaKey !== 'string') {
                this.mfaKey = '';
            }
            if (typeof this.mfaCode !== 'string') {
                this.mfaCode = '';
            }
            this.$nextTick(() => {
                let qrCode = new QRCodeGenerator({
                    width: '200px',
                    height: '200px',
                    mode: 'SVG',
                    value: this.mfaCode,
                    displayText: {
                        visibility: false
                    }
                });
                qrCode.appendTo('#mfaQRCode');
            });
        },
        async save() {
            if (/openvmsSetupMFA/g.test(window.name)) {
                window.close();
            } else {
                if (this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.componentDialogs && this.$parent.$parent.$parent.componentDialogs[0] && this.$parent.$parent.$parent.componentDialogs[0].cancelButton) {
                    this.$parent.$parent.$parent.componentDialogs[0].cancelButton.click();
                }
            }
        }
    }
};

componentStore.initComponent(vmsSetupMFACmp, vmsSetupMFAConfig);
export { vmsSetupMFAConfig, vmsSetupMFACmp };
export default vmsSetupMFACmp;
</script>

<style>
#dialog_container_openvmsSetupMFA, #dialog_container_openvmsSetupMFA > div {
    height: 400px;
}
.vmsSetupMFA-title {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #41362f;
}
.vmsSetupMFA-instructionsWrapper {
    margin-top: 20px;
    width: 100%;
    font-size: 15px;
    line-height: 1.4;
}
.vmsSetupMFA-mfaKey {
    text-align: center;
    font-weight: bold;
}
.vmsSetupMFA-qrCodeWrapper {
    display: flex;
    justify-content: center
}
</style>
<style scoped>
:deep(.vmsSetupMFA-wrapper) {
    width: 100%;
    height: 400px;
    background-color: #fff;
    padding: 20px;
}
:deep(.is-from-popup) {
    width: 100%;
    height: 100%;
}
:deep(.vmsSetupMFA-buttons) {
    text-align: center;
    margin-top: 20px;
    clear: both;
}
:deep(.vmsSetupMFA-button) {
    display: inline-block;
    width: 90px;
}
</style>
